import {Typography} from '@mui/material';

import styles from './Messages.module.css';

export const ErrorMessage = ({message}) => <Typography className={styles.errorMessage}>{message}</Typography>;
